module.exports = __webpack_public_path__ + "static/media/bpmAssistant.55f30f61.png";